import { AIModel } from '@/types/TAIModel';
import { Country, TwilioCountryCode } from '@/types/TCountriesData';

export const getAIModels = async (): Promise<AIModel[]> => {
	const response = await fetch('/static/aIModel.json');

	return response.json();
};

export const getLanguages = async (): Promise<string[]> => {
	const response = await fetch('/static/languages.json');

	return response.json();
};

export const getCountriesList = async (): Promise<Country[]> => {
	const response = await fetch('/static/countries.json');

	return response.json();
};

export const getTwilioSupportedCountries = async (): Promise<TwilioCountryCode[]> => {
	const response = await fetch('/static/twilioSupportedCountries.json');

	return response.json();
};

export const getTwilioSupportedCountriesNovi = async (): Promise<TwilioCountryCode[]> => {
	const response = await fetch('/static/twilioSupportedCountriesNovi.json');

	return response.json();
};
